<script lang="ts">
	import { DateFormatter, getDayOfWeek, parseDate } from '@internationalized/date';
	import type { SelectCourseOfferingDate } from '$db/tables';

	interface Props {
		courseOfferingDates: SelectCourseOfferingDate[];
	}

	let { courseOfferingDates }: Props = $props();

	const dayDict: { [key: number]: string } = {
		0: 'Mo',
		1: 'Di',
		2: 'Mi',
		3: 'Do',
		4: 'Fr',
		5: 'Sa',
		6: 'So'
	};
</script>

<div class="flex items-center gap-6">
	{#each courseOfferingDates as date}
		<div class="flex flex-col gap-2">
			<div class={date.cancelled ? 'text-destructive' : ''}>
				<div>
					{new DateFormatter('de', { dateStyle: 'short' }).format(new Date(date.date))}, {dayDict[
						getDayOfWeek(parseDate(date.date), 'de-DE')
					]}
				</div>
				<div class="text-muted-foreground">
					{date.startTime.slice(0, 5)} - {date.endTime.slice(0, 5)}
				</div>
			</div>
			{#if date.cancelled}
				<div class="max-w-[30ch] text-xs text-muted-foreground">
					Dieser Termin wurde abgesagt. Sämtlicher Inhalt wird innerhalb der restlichen
					Ausbildungszeit vermittelt.
				</div>
			{/if}
		</div>
	{/each}
</div>
